<script lang="ts">
  import DashCard from '../shared/DashCard.svelte';
  import { Hospital, Ingresos } from '../../../lib/api';
  import { session } from '../../../lib/auth.svelte';

  let { limit = 8, interactive = true }: { limit?: number; interactive?: boolean } = $props();

  type KardexRow = {
    id?: string;
    medicamentoId?: string;
    dosis?: string;
    via?: string;
    horaProgramada?: string;
    pacienteId?: string;
    estado?: string;
  };

  let rows = $state<KardexRow[]>([]);
  let error = $state<string | null>(null);
  let busy = $state<string | null>(null);

  async function cargar() {
    error = null;
    try {
      const all = await Hospital.kardexPendientes();
      const todos = Array.isArray(all) ? all : [];
      try {
        const ingresos = await Ingresos.activos();
        const activos = new Set(
          (Array.isArray(ingresos) ? ingresos : [])
            .map((i: { pacienteId?: string }) => i.pacienteId)
            .filter(Boolean) as string[],
        );
        rows = todos.filter((r: KardexRow) => r.pacienteId && activos.has(r.pacienteId)).slice(0, limit);
      } catch {
        rows = todos.slice(0, limit);
      }
    } catch (e: any) {
      error = e?.message ?? String(e);
    }
  }

  async function administrar(id: string) {
    if (!id) return;
    busy = id;
    try {
      await Hospital.administrar(id, session.value?.usuario ?? 'enfermeria');
      await cargar();
    } catch (e: any) {
      error = e?.message ?? String(e);
    } finally {
      busy = null;
    }
  }

  function hora(iso?: string) {
    if (!iso) return '—';
    try { return new Date(iso).toLocaleTimeString('es-GT', { hour: '2-digit', minute: '2-digit' }); }
    catch { return iso; }
  }

  $effect(() => { cargar(); const t = setInterval(cargar, 45000); return () => clearInterval(t); });
</script>

<DashCard title="Kárdex pendientes" hint="{rows.length} dosis">
  {#snippet actions()}
    <button type="button" class="btn-sm" onclick={cargar}>↻</button>
  {/snippet}
  {#if error}<p class="err">{error}</p>{/if}
  {#if rows.length === 0 && !error}
    <p class="empty">Sin administraciones pendientes.</p>
  {:else}
    <table class="dash-table">
      <thead><tr><th>Hora</th><th>Dosis</th><th>Vía</th>{#if interactive}<th class="th-act">Acción</th>{/if}</tr></thead>
      <tbody>
        {#each rows as r (r.id)}
          <tr>
            <td class="dash-mono">{hora(r.horaProgramada)}</td>
            <td>{r.dosis ?? r.medicamentoId?.slice(0, 8) ?? '—'}</td>
            <td>{r.via ?? '—'}</td>
            {#if interactive}
              <td>
                <button type="button" class="btn-ok" disabled={busy === r.id} onclick={() => r.id && administrar(r.id)}>
                  {busy === r.id ? '…' : 'Administrar'}
                </button>
              </td>
            {/if}
          </tr>
        {/each}
      </tbody>
    </table>
  {/if}
</DashCard>

<style>
  .btn-sm { border: 1px solid var(--border); background: var(--bg-surface); border-radius: 6px; cursor: pointer; padding: 0.15rem 0.45rem; font-size: 0.78rem; }
  .btn-ok { border: 0; background: var(--success); color: #fff; border-radius: 6px; padding: 0.2rem 0.5rem; font-size: 0.72rem; cursor: pointer; }
  .btn-ok:disabled { opacity: 0.6; cursor: wait; }
  .err, .empty { margin: 0; font-size: 0.85rem; color: var(--text-secondary); }
  .err { color: var(--danger); }
</style>
